import { useDeletePlace } from "./api/deletePlace";
import { Button } from "reactstrap";


const DeletePlace = ({handleCloseModal, placeId}: DeletePlaceProps)  => {
  
  const deletePlaceMutation = useDeletePlace({ placeId});
  const handleSubmit = async (): Promise<void> => {
    deletePlaceMutation.mutateAsync({ 
      placeId: placeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Τοποθεσία;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeletePlaceProps{
  placeId: number;
  handleCloseModal: () => void;
}

export default DeletePlace;